tippy('[data-tippy-content]', {
  placement: "bottom"
});

document.querySelectorAll("[data-swatches-container]").forEach(e => {
  var productBundle = document.querySelector('.bundle_form');
  var panel;
  const swatchContainer = e;
  const swatchSelectButtons = swatchContainer.querySelectorAll("[data-select-id]");
  const swatchContents = swatchContainer.querySelectorAll("[data-contents-id]");

  swatchSelectButtons.forEach(button => {
    
    button.addEventListener("click", e => {

      const button = e.currentTarget;
      const buttonTitle = button.querySelector('.select-navigation-item__title');
      const buttonSwatch = button.querySelector('.select-navigation-item__swatch');
      const contentsItemId = button.dataset.selectId;
      const contentsItem = swatchContainer.querySelector('[data-contents-id="' + contentsItemId + '"]');
      const menu = swatchContainer.querySelector('[data-tippy-menu]');
      const menuTitle = menu.querySelector('.select-navigation-item__title');
      const menuSwatch = menu.querySelector('.select-navigation-item__swatch');
      const menuPopover = menu._tippy;

      // Replace the title in the menu

      menu.replaceChild(buttonTitle.cloneNode(true), menuTitle);
      menu.replaceChild(buttonSwatch.cloneNode(true), menuSwatch);

      // Hide all contents except for the selected one.

      swatchContents.forEach(e => {
        e.classList.remove('tab-contents-item--active');
      });

      contentsItem.classList.add('tab-contents-item--active');

      // Close the menu

      menuPopover.hide();
      
      if(typeof productBundle != 'undefined' && productBundle != null) {
        panel = menu.parentElement.parentElement.parentElement;

        if(panel.classList.contains('collection-swatch-panel')) {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      }
    });

  });

});

document.querySelectorAll("[data-swatches-container]").forEach(e => {

  const swatchContainer = e;
  const swatchSelectButtons = swatchContainer.querySelectorAll("[data-select-id]");

});

document.querySelectorAll('[data-tippy-menu]').forEach(e => {

  const tippyMenu = e;
  const navigationId = tippyMenu.dataset.menuId;
  const menuQuerySelector = '[data-select-navigation-popover="' + navigationId + '"]';
  const menuContent = document.querySelector(menuQuerySelector);

  tippy(tippyMenu, {
    trigger: 'click',
    interactive: true,
    // arrow: false,
    content: menuContent,
    // allowHTML: true,
    theme: "nugenesis-dropdown",
    placement: "bottom",
    // offset: [0,0]
  });

});

// Accordion Feature

document.addEventListener('DOMContentLoaded', function(){
  
  var productBundle = document.querySelector('.bundle_form');
  var bundleAccordionBtns = document.querySelectorAll('.collection-swatches-meta');
  var bundleBtns = document.querySelectorAll('.AddtoBundle');
  
  if(typeof productBundle != 'undefined' && productBundle != null) {
    bundleAccordionBtns.forEach(function(btn) {
      btn.addEventListener('click', function(){
        this.classList.toggle("active");
        var panel = this.nextElementSibling;

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });

    //Swatches Action
    var addToCartBtn = document.getElementById('addToCart');
    var collectionBlocks = document.querySelectorAll('.collection-swatches-container-block');
    var collectionMetaName = [], collectionImages = [], collectionImagesMobile = [], collectionSelectedColor = [], collectionSelectedVariant = [];
    var collectionSwatches, countSelected;
    var bundleForm = document.querySelector('form.bundle_form');
    var productPrice = document.querySelector('.product-price');
    
    if(collectionBlocks.length > 0) {
      collectionImages = document.querySelectorAll('#colors-thumbnail-desktop .collection-bundle-featured-image');
      collectionImagesMobile = document.querySelectorAll('#colors-thumbnail-mobile .collection-bundle-featured-image');
      
      collectionBlocks.forEach(function(block, index){
        collectionSwatches = block.querySelectorAll('.collection-swatch');
        collectionMetaName[index] = block.querySelector('.collection-swatches-meta__selected');
        collectionSelectedColor[index] = block.querySelector('[data-collection-color]');
        collectionSelectedVariant[index] = block.querySelector('.selected-collection-swatch');

        collectionSwatches.forEach(function(swatch){
          swatch.addEventListener('click', function(e){
            e.preventDefault();
            var swatchVariants = this.dataset.variantIds.split(',');

            collectionSelectedVariant[index].dataset.productHandle = this.dataset.productHandle;
            collectionSelectedVariant[index].dataset.productName = this.dataset.productName;
            collectionSelectedVariant[index].value = swatchVariants[bundleForm.id.selectedIndex];
            collectionMetaName[index].innerText = this.dataset.tippyContent;
            collectionImages[index].style.backgroundImage = 'url(' + this.dataset.featuredImage + ')';
            collectionImagesMobile[index].style.backgroundImage = 'url(' + this.dataset.featuredImage + ')';

            //Remove current class
            collectionSelectedColor[index].className = '';
            collectionSelectedColor[index].classList.add('collection-swatch--' + this.dataset.swatchId);
            
            //Remove current active
            if(this.parentElement.parentElement.parentElement.querySelector('.collection-swatch--active') !== null) {
              this.parentElement.parentElement.parentElement.querySelector('.collection-swatch--active').classList.remove('collection-swatch--active');
            }
            this.classList.add('collection-swatch--active');
            
            //Remove current selected
            if(this.parentElement.parentElement.parentElement.querySelector('.collection-swatch--selected') !== null) {
              this.parentElement.parentElement.parentElement.querySelector('.collection-swatch--selected').classList.remove('collection-swatch--selected');
            }
            this.classList.add('collection-swatch--selected');
            
          });
        });
      });

      bundleForm.id.addEventListener('change', function(e){        
        collectionBlocks.forEach(function(block){
          var selectedSwatch = block.querySelector('.collection-swatch--selected');
          var variantsIds = selectedSwatch.dataset.variantIds.split(',');
          block.querySelector('.selected-collection-swatch').value = variantsIds[e.target.selectedIndex];
        });
        
        //Set the price
        setPrice(collectionBlocks, bundleForm, productPrice);
      });
      
      bundleBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e){
          e.preventDefault();
  
          var panel = this.parentElement;
          var blockMeta = panel.previousElementSibling;
          blockMeta.classList.toggle("active");
          blockMeta.classList.add('selected');
          
          panel.parentElement.querySelector('.selected-collection-swatch').classList.add('color-selected');
  
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
  
          //Check all the colors
          countSelected = document.querySelectorAll('.color-selected');
          console.log(countSelected.length);
          if(countSelected.length == collectionBlocks.length) {
            addToCartBtn.removeAttribute('disabled');
          }
        });
      });

      //Set the price
      setPrice(collectionBlocks, bundleForm, productPrice);
    }


  }
  
  function setPrice(blocks, select, priceDOM) {
    var productPrice = select.id.children[select.id.selectedIndex];
    var price = productPrice.dataset.price;
    
    var variantsPriceSum = 0;
    var variantPriceString, variantPrice, variantPricesArr, finalPrice;

    blocks.forEach(function(block) {
      variantPriceString = block.querySelector('.collection-swatch--selected');
      variantPricesArr = variantPriceString.dataset.prices.split(',');
      variantPrice = variantPricesArr[select.id.selectedIndex];

      variantsPriceSum = variantsPriceSum + parseInt(variantPrice);
    });

    finalPrice = variantsPriceSum + parseInt(price);

    priceDOM.innerText = Shopify.formatMoney(price);
  }
  //Form actions added to the theme.js.liquid  
});